(function () {
	'use strict';
	$(document).ready(function () {

		if ($('.transport-form').length) {
			function sendTransportForm() {
				var transportFormData = new FormData(document.getElementById('transport-form'));

				var transportFormDataObject = {};
				transportFormData.forEach(function(value, key){
					if (transportFormDataObject[key] !== undefined) {
						transportFormDataObject[key] += ', ' + value;
					} else {
						transportFormDataObject[key] = value;
					}
				});
				var transportFormDataJson = JSON.stringify(transportFormDataObject);

				var nonce = fhGetConfig('nonce');

				$.ajax({
					url: "/wp-admin/admin-ajax.php",
					method: "post",
					timeout: 10000,
					data: {
						action: "send_transport_form",
						transportFormDataJson: transportFormDataJson,
						nonce: nonce,
					},
					success: function (data) {
						if (data == '1') {
							$('.ajax-success').slideDown();
							$('#transport-form').trigger("reset");
						} else {
							$('.ajax-error').slideDown();
						}
					},
					error: function () {
						$('.ajax-error').slideDown();
					},
					beforeSend: function () {
						$('.ajax-success').slideUp();
						$('.ajax-error').slideUp();
						$('.ajax-loading').slideDown();
					},
					complete: function () {
						$('.ajax-loading').slideUp();
					},
				});
			}

			$('input[name="rodzaj-przewozu[]"]').on('change', function() {
				if ($('input[name="rodzaj-przewozu[]"]:checked').length < 1) {
					$('#error-rodzaj-przewozu').slideDown();
				} else {
					$('#error-rodzaj-przewozu').slideUp();
				}
			});

			$('input[name=wlasnosc-wagonu]').on('change', function() {
				var type = $(this).attr("id").split("-")[2];
				$("#etykieta-rodzaj-wagonu").attr("for", "rodzaj-wagonu-" + type);
				$("#rodzaj-wagonu-" + type).show().attr("disabled", false);
				$("#rodzaj-wagonu-" + type).siblings("select").hide().attr("disabled", true).prop('selectedIndex', 0);

				$('#seria-wagonu').attr("disabled", type !== 'pkpcargo' ? true : false);
			});

			$('input[name="akceptacja-dane-osobowe"]').on('change', function() {
				if ($('input[name="akceptacja-dane-osobowe"]:checked').length < 1) {
					$('#error-akceptacja-dane-osobowe').slideDown();
				} else {
					$('#error-akceptacja-dane-osobowe').slideUp();
				}
			});

			$('input[name=towar]').on('change', function() {
				var type = $(this).attr("id").split("-")[1];
				$('#rodzaj-opakowania').attr("disabled", type !== 'opakowanie' ? true : false);
			});

			$('input[required]').on('change', function() {
				if ($(this).val()) {
					$(this).siblings('.form-error').slideUp();
				} else {
					$(this).siblings('.form-error').slideDown();
				}
			});

			$('#transport-form').on('submit', function (e) {
				e.preventDefault();

				$('#transport-form .form-error').hide();
				var isAllValid = true;

				if ($('input[name="rodzaj-przewozu[]"]:checked').length < 1) {
					$('#error-rodzaj-przewozu').slideDown();
					isAllValid = false;
				} else {
					$('#error-rodzaj-przewozu').slideUp();
				}

				if ($('input[name="akceptacja-dane-osobowe"]:checked').length < 1) {
					$('#error-akceptacja-dane-osobowe').slideDown();
					isAllValid = false;
				} else {
					$('#error-akceptacja-dane-osobowe').slideUp();
				}

				var fieldsToValidationText = $('input[required]');
				$(fieldsToValidationText).each(function (index, element) {
					if (!$(element).val()) {
						$(this).siblings('.form-error').slideDown();
						isAllValid = false;
					}
				});

				if (!isAllValid) {
					$("html, body").animate({
						scrollTop: $('.form-error[style*="display: block"]').offset().top - 120
					}, 1000);
					return;
				}

				sendTransportForm();
			});

		}

	});
}(jQuery));
